import { Portal } from '../Configs';
import { portal } from '../Configs/general';

export const DEPARTMENTS_GDC = {
  Atlantico: 'Atlántico',
  Cesar: 'Cesar',
  Magdalena: 'Magdalena'
};

const DEPARTMENTS_BY_PORTAL = {
  [Portal.Gascaribe]: DEPARTMENTS_GDC,
  [Portal.Efigas]: {},
  [Portal.Gasguajira]: {}
};

export const DEPARTMENTS = DEPARTMENTS_BY_PORTAL[portal];

const LOCALITIES_GDC = {
  [DEPARTMENTS.Atlantico]: {
    Baranoa: 'Baranoa',
    Barranquilla: 'Barranquilla',
    CampoDeLaCruz: 'Campo de la Cruz',
    Candelaria: 'Candelaria',
    Galapa: 'Galapa',
    JuanDeAcosta: 'Juan de Acosta',
    Luruaco: 'Luruaco',
    Malambo: 'Malambo',
    Manati: 'Manatí',
    PalmarDeVarela: 'Palmar de Varela',
    Piojo: 'Piojó',
    Polonuevo: 'Polonuevo',
    Ponedera: 'Ponedera',
    PuertoColombia: 'Puerto Colombia',
    Repelon: 'Repelón',
    Sabanagrande: 'Sabanagrande',
    Sabanalarga: 'Sabanalarga',
    SantaLucia: 'Santa Lucía',
    SantoTomas: 'Santo Tomás',
    Soledad: 'Soledad',
    Suan: 'Suán',
    Tubara: 'Tubará',
    Usiacuri: 'Usiacurí'
  },
  [DEPARTMENTS.Cesar]: {
    Aguachica: 'Aguachica',
    AgustinCodazzi: 'Agustín Codazzi',
    Astrea: 'Astrea',
    Becerril: 'Becerril',
    Bosconia: 'Bosconia',
    Chimichagua: 'Chimichagua',
    Chiriguana: 'Chiriguaná',
    Curumani: 'Curumaní',
    ElCopey: 'El Copey',
    ElPaso: 'El Paso',
    Gamarra: 'Gamarra',
    Gonzalez: 'González',
    LaGloriaCesar: 'La Gloria (Cesar)',
    'LaJagua eIbirico': 'La Jagua de Ibirico',
    LaPaz: 'La Paz',
    ManaureBalconDelCesar: 'Manaure Balcón del Cesar',
    Pailitas: 'Pailitas',
    Pelaya: 'Pelaya',
    PuebloBello: 'Pueblo Bello',
    RioDeOro: 'Río de Oro',
    SanAlberto: 'San Alberto',
    SanDiego: 'San Diego',
    SanMartin: 'San Martín',
    Tamalameque: 'Tamalameque',
    Valledupar: 'Valledupar'
  },
  [DEPARTMENTS.Magdalena]: {
    Algarrobo: 'Algarrobo',
    Aracataca: 'Aracataca',
    Ariguani: 'Ariguaní',
    CerroDeSanAntonio: 'Cerro de San Antonio',
    Chibolo: 'Chibolo',
    Cienaga: 'Ciénaga',
    Concordia: 'Concordia',
    ElBanco: 'El Banco',
    ElPinon: 'El Piñón',
    ElReten: 'El Retén',
    Fundacion: 'Fundación',
    Guamal: 'Guamal',
    NuevaGranada: 'Nueva Granada',
    Pedraza: 'Pedraza',
    PijinoDelCarmen: 'Pijiño del Carmen',
    Pivijay: 'Pivijay',
    Plato: 'Plato',
    PuebloViejo: 'Pueblo Viejo',
    Remolino: 'Remolino',
    SabanasDeSanAngel: 'Sabanas de San Ángel',
    Salamina: 'Salamina',
    SanSebastianDeBuenavista: 'San Sebastián de Buenavista',
    SanZenon: 'San Zenón',
    SantaAna: 'Santa Ana',
    SantaBarbaraDePinto: 'Santa Bárbara de Pinto',
    SantaMarta: 'Santa Marta',
    Sitionuevo: 'Sitionuevo',
    Tenerife: 'Tenerife',
    Zapayan: 'Zapayán',
    ZonaBananera: 'Zona Bananera'
  }
};

const LOCALITIES_BY_PORTAL = {
  [Portal.Gascaribe]: LOCALITIES_GDC,
  [Portal.Efigas]: {},
  [Portal.Gasguajira]: {}
};

export const LOCALITIES = LOCALITIES_BY_PORTAL[portal];

export const DEFAULT_DEPARTMENT = 'Seleccione un departamento';

export const DEFAULT_LOCALITY = 'Seleccione un municipio';

export const DEPARTMENT_OPTIONS = [
  { label: DEFAULT_DEPARTMENT, value: DEFAULT_DEPARTMENT },
  ...Object.values(DEPARTMENTS).map(department => ({
    label: department,
    value: department
  }))
];

export const LOCALITY_OPTIONS = Object.keys(LOCALITIES)
  .map(department => ({
    [department]: [
      { label: DEFAULT_LOCALITY, value: DEFAULT_LOCALITY },
      ...Object.values(LOCALITIES[department]).map(locality => ({
        label: locality,
        value: locality
      }))
    ]
  }))
  .reduce((acc, curr) => ({ ...acc, ...curr }), {
    [DEFAULT_DEPARTMENT]: [{ label: DEFAULT_LOCALITY, value: DEFAULT_LOCALITY }]
  });
